import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useStockTakeList = () => {
  const [loading, setLoading] = useState(false);
  const [stockTakeList, setStockTakeList] = useState({});
  const [pageRef, setpageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getStockTakeList = (params = {}) => {
    setLoading(true);

    axiosClient
      .get(`Operation/StockTake/List?Guid=${params?.zoneGuid}`, { params })
      .then(res => {
        if (res.status === 200) {
          setpageRef(res.data.value);
          if (res.data.value.items && res.data.value.items.length > 0) {
            setStockTakeList(prev => {
              const orderedList = res.data.value.items.map(element => ({
                id: element.guid,
                title: element.title,
                type: element.type,
                agent: element.agentName,
                shortCode: element.shortCode,
                createTime: element.dateTime,
                //   hasGraph: element.hasGraph,
                //   imageKey: element.imageKey,
                //   imageURL: element.imageURL,
              }));

              return { ...prev, [params?.page || 1]: orderedList };
            });
          }
          enqueueSnackbar('انبارگردانی یافت نشد.', { variant: 'info' });
        } else {
          enqueueSnackbar(res.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getStockTakeList, loading, stockTakeList, pageRef];
};

export default useStockTakeList;
